var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('cell-value',_vm._b({attrs:{"row":_vm.row,"field":_vm.field,"editable":_vm.editable},on:{"edit":_vm.onEdited}},'cell-value',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }